'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCatalogItemsLoading = exports.getLoadTimeForCatalogItems = exports.shouldFetchBiddingInfoForCatalog = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _biddingInfo = require('../modules/biddingInfo');

var _catalogItems = require('../modules/catalogItems');

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUX_STORE_TIME_CATALOG = (0, _ms2.default)('5m');

// reducer
var DEFAULT_STATE = {
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var loaded = (0, _extends3.default)({}, state.loaded);
    var loading = [].concat((0, _toConsumableArray3.default)(state.loading));
    var time = void 0;

    switch (action.type) {
        case _biddingInfo.LOAD_CATALOG_BIDDING_REQUEST:
        case _biddingInfo.LOAD_CATALOG_BIDDING_SUCCESS:
        case _catalogItems.LOAD_CATALOG_ITEMS_REQUEST:
        case _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS:
            time = action.meta.actionTime;

            if (action.type === _biddingInfo.LOAD_CATALOG_BIDDING_REQUEST) {
                loading = (0, _union2.default)(loading, ['catalog-bidding-info-' + action.payload]);
            }

            if (action.type === _biddingInfo.LOAD_CATALOG_BIDDING_SUCCESS) {
                var id = action.meta.catalogId;
                loaded['catalog-bidding-info-' + id] = time;
                loading = (0, _difference2.default)(loading, ['catalog-bidding-info-' + id]);
            }

            // TODO: make this a pure function by moving the global
            if (action.type === _catalogItems.LOAD_CATALOG_ITEMS_REQUEST && !global.__SERVER__) {
                action.payload.forEach(function (id) {
                    loading = (0, _union2.default)(loading, ['catalog-items-' + id]);
                });
            }

            if (action.type === _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS && !global.__SERVER__) {
                // TODO: why is catalogId not plural?
                action.meta.catalogId.forEach(function (id) {
                    loaded['catalog-items-' + id] = time;
                    loading = (0, _difference2.default)(loading, ['catalog-items-' + id]);
                });
            }

            return (0, _extends3.default)({}, state, {
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.loaded;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getLoadTimeForCatalogBidding = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded['catalog-bidding-info-' + id] || 0;
});

var isCatalogBiddingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes('catalog-bidding-info-' + id);
});

var shouldFetchBiddingInfoForCatalog = exports.shouldFetchBiddingInfoForCatalog = (0, _reselect.createSelector)([idSelector, getLoadTimeForCatalogBidding, isCatalogBiddingLoading], function (catalogId, loaded, loading) {
    if (!catalogId) return false;
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME_CATALOG) return false;
    return !loading;
});

var getLoadTimeForCatalogItems = exports.getLoadTimeForCatalogItems = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded['catalog-items-' + id] || 0;
});

var isCatalogItemsLoading = exports.isCatalogItemsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes('catalog-items-' + id);
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/loaded.js
// module id = N5um
// module chunks = 57